/**
 * /devhub/requests — Tenant requests (operator review). Surface Layer (/01).
 *
 * REQ-001.91 DevHub UI rebuild · Phase 2 (already-live domains). Reuses the live `DevHubRequestReview`
 * panel (live `/api/devhub/action-requests` + evidence + approve / reject / reindex). Apply-completion
 * and any enqueue are worker-gated and shown honestly as pending inside the panel. Operator-only
 * (routePolicy plane guard + the panel's own role gate).
 */

import { createFileRoute } from '@tanstack/react-router';

import { DevHubRequestReview } from '../components/devhub/DevHubRequestReview';

export const Route = createFileRoute('/devhub/requests')({ component: DevHubRequestsPage });

function DevHubRequestsPage() {
  return <DevHubRequestReview />;
}
